<script setup lang="ts">
import { useId } from 'vue'

import type { SupportedLocale } from '@/lib/constants'

defineProps<{ locale: SupportedLocale }>()

const clipId = useId()
</script>

<template>
  <svg viewBox="0 0 60 40" class="h-4 w-6 shrink-0 rounded-sm ring-1 ring-black/10" aria-hidden="true">
    <template v-if="locale === 'tr'">
      <rect width="60" height="40" fill="#E30A17" />
      <circle cx="22" cy="20" r="8" fill="#fff" />
      <circle cx="24.5" cy="20" r="6.4" fill="#E30A17" />
      <polygon
        fill="#fff"
        points="37.6,20 35.13,20.82 35.11,23.42 33.57,21.33 31.09,22.12 32.6,20 31.09,17.88 33.57,18.67 35.11,16.58 35.13,19.18"
      />
    </template>
    <template v-else-if="locale === 'de'">
      <rect width="60" height="13.34" y="0" fill="#000" />
      <rect width="60" height="13.33" y="13.34" fill="#DD0000" />
      <rect width="60" height="13.33" y="26.67" fill="#FFCE00" />
    </template>
    <template v-else>
      <defs>
        <clipPath :id="clipId">
          <rect width="60" height="40" />
        </clipPath>
      </defs>
      <g :clip-path="`url(#${clipId})`">
        <rect width="60" height="40" fill="#012169" />
        <path d="M0,0 L60,40 M60,0 L0,40" stroke="#fff" stroke-width="8" />
        <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" stroke-width="4" />
        <path d="M30,0 V40 M0,20 H60" stroke="#fff" stroke-width="14" />
        <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" stroke-width="8" />
      </g>
    </template>
  </svg>
</template>
